<div *ngIf="viewGrid">
  <div nz-row>
    <div nz-col nzSpan="6">
      <span class="pageTitle">Responded Query</span>
    </div>
    <div nz-col nzSpan="8">
      <div class="search-container">
        <nz-input-group [nzPrefix]="searchIcon">
          <input nz-input type="text" placeholder="Enter minimum 3 characters to search..." [(ngModel)]="searchText"
          (input)="currentUser.Is_Partner? searchQuery() : searchQueryByKeyword()" class="search-box" />
        </nz-input-group>
        <ng-template #searchIcon>
          <i nz-icon nzType="search"></i>
        </ng-template>
  
  
      </div>
    </div>
    <div nz-col nzSpan="10">
      <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
        
        <button nz-button *ngIf="filteredQueryRequest.length > 0" nzType="primary" (click)="exportToExcel()">
          <i nz-icon nzType="file-excel" nzTheme="outline" style="color: white;"></i> Export to Excel
        </button>
      </div>
  
    </div>
  </div>

  <!-- <div nz-row>
    
    <div nz-col nzSpan="8" *ngIf="currentUser.Is_Partner">
      <div class="search-container">
        <nz-input-group [nzPrefix]="searchIcon">
          <input nz-input type="text" placeholder="Enter minimum 3 characters to search..." [(ngModel)]="searchText"
            (input)="currentUser.Is_Partner? searchQuery() : searchQueryByKeyword()" class="search-box" />
        </nz-input-group>
        <ng-template #searchIcon>
          <i nz-icon nzType="search"></i>
        </ng-template>
      </div>
    </div>
    <div nz-col nzSpan="10" *ngIf="currentUser.Is_Partner">
      <div class="button-container"
        style="display: flex; justify-content: flex-end; align-items: center; float: right;">
        <button nz-button *ngIf="filteredQueryRequest.length > 0" nzType="primary" (click)="exportToExcel()">
          <i nz-icon nzType="file-excel" nzTheme="outline"></i> Export to Excel
        </button>
      </div>
    </div>
  </div> 

  <div class="row" *ngIf="!currentUser.Is_Partner">
    <div class="col-md-3 col-md-push-8">
      <input type="text" placeholder="Enter minimum 3 characters to search" [maxlength]="50" [(ngModel)]="searchText"
        (keyup)="resetFilter()" class="form-control" />
    </div>
    <div class="col-md-1 pull-right">
      <button (click)="searchQueryByKeyword()" [disabled]="!(searchText.trim().length > 2)" class="btn btn-primary"
        value="Search">Search</button>
    </div>
  </div>-->
  <br>

  <nz-table *ngIf="currentUser.Is_Partner" #partnerTable [nzScroll]="{ x: '1500px' }" [nzData]="filteredQueryRequest"
    [nzBordered]="true" [nzPageSize]="10" [nzSize]="'small'" [nzShowPagination]="true">
    <thead>
      <tr>
        <th *ngFor="let column of partnerTableColumns" [nzSortFn]="column.compare" [nzSortPriority]="column.priority"
          [nzShowSort]="column.showShort" style="padding: 1px 10px; font-size: 11px; font-weight: 100;width: 150px;">
          {{ column.title }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let query of partnerTable.data">

        <td class="text-center">
          <a class="referanceNumber" style="cursor: pointer; font-size: 11px; "
            (click)="showQueryDetails(query.QueryCode, query.QueryDetailCode,query.QueryRequestNumber,query.Subject)">
            {{query.QueryRequestNumber}}
          </a>
        </td>
        <td>{{query.Subject}}</td>
        <td>{{query.PartnerQueryStatus}}</td>
        <td>{{query.RequestorName}}</td>
        <td>{{query.CompanyName}}</td>
        <td>{{query.Block}}</td>
        <td>{{query.RequestedDate | date:'dd-MMM-yyyy' }}</td>
        <td>{{query.PriorityLevel}}</td>
        <td>{{query.Confidential}}</td>
        <td>{{query.Department}}</td>
        <td>{{query.SubDeptartment}}</td>
        <td>{{query.RespondedDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
        <td>{{query.CreatedByUserName}}</td>
      </tr>
    </tbody>
  </nz-table>



  <nz-table *ngIf="!currentUser.Is_Partner" #nonPartnerTable [nzScroll]="{ x: '1500px' }"
    [nzData]="filteredQueryRequest" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true">
    <thead>
      <tr>
        <th *ngFor="let column of nonPartnerTableColumns" [nzSortFn]="column.compare" [nzSortPriority]="column.priority"
          [nzShowSort]="column.showShort" style="padding: 2px 10px; font-size: 12px; font-weight: 100;">
          {{ column.title }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let query of nonPartnerTable.data">
        <td class="text-center" style=" width: 150px; font-size: 80%;">
          <a class="referanceNumber" style="cursor: pointer; font-size: 10px; "
            (click)="showQueryDetails(query.QueryCode, query.QueryDetailCode,query.QueryRequestNumber,query.Subject)">
            {{query.QueryRequestNumber}}
          </a>
        </td> 
        <td class="text-center" width="300px"><strong>{{query.Subject}}</strong></td>
        <td class="text-center"><strong>{{query.QueryStatus}}</strong></td>
        <td class="text-center">{{query.RequestorName}}</td>
        <td class="text-center">{{query.RequestedDate | date:'dd-MMM-yyyy' }}</td>
        <td class="text-center">{{query.Category}}</td>
        <td class="text-center">{{query.SubCategory}}</td>
        <td class="text-center">{{query.Block}}</td>
        <td class="text-center">{{query.PriorityLevel}}</td>
        <td class="text-center">{{query.Confidential}}</td>
        <td class="text-center">{{query.Department}}</td>
        <td class="text-center">{{query.SubDeptartment}}</td>
        <td class="text-center">{{query.RespondedDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
        <td class="text-center">{{query.CreatedByUserName}}</td>
      </tr>
    </tbody>
  </nz-table>
</div>

<div class="Layoutcontainer" *ngIf="!viewGrid">
  <div nz-row>
    <div nz-col nzSpan="12">
      <h4 class="pageTitle">Query Reference Number -<strong> {{queryReferenceNumber}}</strong></h4>
    </div>
    <div nz-col nzSpan="12">
      <div class="button-container"
        style="display: flex; justify-content: flex-end; align-items: center; float: right;">
        <button nz-button nzType="primary" (click)="exportAsPDF()" data-toggle="tooltip" data-placement="top"
          title="Export As PDF">
          <i nz-icon nzType="file-pdf" nzTheme="outline" style="color: white;"></i> Export to PDF
        </button>
      </div>

    </div>
  </div>


  <br>

  <div id="MyDIv">

    <div *ngIf="partnerUserMaster.length > 0 && CCSubDepartmentsMaster.length > 0">
      <app-query-detail-info [Subject]="Subject" [queryDetail]="queryDetail" [partnerUserMaster]="partnerUserMaster"
        [CCSubDepartmentsMaster]="CCSubDepartmentsMaster">
      </app-query-detail-info>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-3 col-md-push-2">
      <button (click)="redirectBack()" nz-button nzType="primary" >
        Back
      </button>
    </div>
  </div>
</div>